import { render, staticRenderFns } from "./importOrder.vue?vue&type=template&id=1a2007ee&scoped=true&"
import script from "./importOrder.vue?vue&type=script&lang=js&"
export * from "./importOrder.vue?vue&type=script&lang=js&"
import style0 from "./importOrder.vue?vue&type=style&index=0&id=1a2007ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2007ee",
  null
  
)

export default component.exports